import { Route, Switch } from 'react-router'
import ExploreTable from './ExploreTable'
import MapV2Route from './Mapv2'
import { HighSchoolExplorerOptOut } from 'components/HighSchoolExplorerEarlyAccess'

export default function HighSchoolsRoutes() {
  const ROOT_PATH = import.meta.env.BASE_URL

  return (
    <div>
      <HighSchoolExplorerOptOut />
      <Switch>
        <Route
          path={`${ROOT_PATH}/recruit/highschools`}
          exact
          render={() => <ExploreTable />}
        />
        <Route
          exact
          path={`${ROOT_PATH}/recruit/highschools/map`}
          component={MapV2Route}
        />
      </Switch>
    </div>
  )
}
